<template>
    <modal-page :heading="'Reset your password'">
        <p>Change your password by entering a new one below.</p>
        <form
            class="form grid"
            novalidate
            @submit.prevent="resetPassword">
            <div class="grid__row">
                <div class="grid__col grid__col--100">
                    <label
                        class="reader-only"
                        for="ResetPasswordNewPassword">New Password (min 8 characters)</label>
                    <input
                        autocomplete="new-password"
                        id="ResetPasswordNewPassword"
                        name="ResetPasswordNewPassword"
                        placeholder="New Password (min 8 characters)"
                        ref="ResetPasswordNewPassword"
                        type="password"
                        v-model.trim="newPassword"
                        v-validate.disable="'required|min:8'"
                        :class="{ 'input--invalid': errors.has('ResetPasswordNewPassword') }">
                    <span
                        class="error-message"
                        v-if="errors.has('ResetPasswordNewPassword')">{{ errors.first('ResetPasswordNewPassword') }}</span>
                </div>
            </div>

            <div class="grid__row">
                <div class="grid__col grid__col--100">
                    <label
                        class="reader-only"
                        for="ResetPasswordConfirmNewPassword">Confirm New Password</label>
                    <input
                        id="ResetPasswordConfirmNewPassword"
                        name="ResetPasswordPassword"
                        placeholder="Confirm New Password"
                        type="password"
                        v-validate.disable="'required|confirmed:ResetPasswordConfirmNewPassword'"
                        :class="{ 'input--invalid': errors.has('ResetPasswordConfirmNewPassword') }">
                    <span
                        class="error-message"
                        v-if="errors.has('ResetPasswordConfirmNewPassword')">{{ errors.first('ResetPasswordConfirmNewPassword') }}</span>
                </div>
            </div>

            <div class="grid__row">
                <div class="grid__col grid__col--100">
                    <button
                        class="submit"
                        type="submit"
                        :disabled="isSubmitting">Change Password</button>
                </div>
            </div>
        </form>
    </modal-page>
</template>

<script>
import errorHandleable from '../mixins/ErrorHandleable'
import modalPage from '../components/ModalPage.vue'
import quebecUserModal from '../mixins/QuebecUserModal'

export default {
    beforeCreate () {
        this.htmlPageTitle = `Reset Password at ${this.$config.partnerName}`
    },
    components: {
        modalPage
    },
    data () {
        return {
            isSubmitting: false,
            newPassword: ''
        }
    },
    head: {
        title () {
            return {
                inner: this.htmlPageTitle
            }
        }
    },
    methods: {
        resetPassword () {
            this.isSubmitting = true

            this.$marketplace
                .resetPassword(this.token, {
                    new_password: this.newPassword
                })
                .then(() => this.$router.replace({ name: 'login' }))
                .catch(err => this.catchAndNotify(err))
                .finally(() => {
                    this.isSubmitting = false
                })
        }
    },
    mixins: [
        errorHandleable,
        quebecUserModal
    ],
    props: {
        token: {
            default: '',
            required: true,
            type: String
        }
    }
}
</script>

<style lang="postcss" scoped>
p {
    text-align: center;
}

.form {
    margin-top: 30px;
}
</style>
